export default {
  "landing-page": {
    "enquire-about-dark": "询问",
    "enquire-about-light-1": "加入",
    "enquire-about-light-2": "Popin",
    "card-1-title": "增加客流量的途径",
    "card-1-description":
      "Customisable and easy to use direct marketing capabilities. No digital marketing experience required. Power tools enabling full flexibility as to how and when to reach target customers in order to create awareness and stimulate demand exactly when and how you want it.",
    "card-2-title": "稳定客户",
    "card-2-description":
      "Customisable and engaging loyalty mechanics which encourage customers to digitally check in on every visit. Unique fun, approachable and gamified approach drives up frequency of visits and creates customers who feel rewarded for loyalty.",
    "card-3-title": "更紧密的接触",
    "card-3-description":
      "Digital tools that enable you to communicate directly with customers in a really easy way, know who your best customers are and track your businesses performance with your customers in real-time. All in order to deliver the best digitally-led customer satisfaction.",
    enquire: "询问",
    "i-have-an-account": "已有账户",
    login: "登录",
  },
  dashboard: {
    activeEvents: "活跃活动",
    noActiveEvents: "没有活跃活动",
  },
  "navigation-titles": {
    events: "活动追踪器",
  },
  events: {
    eventsList: "活动列表",
    active: "活跃",
    expired: "已过期",
    noEvents: "没有活动",
    postCode: "帖子ID",
    startDate: "开始日期",
    endDate: "结束日期",
    views: "浏览量",
  },
};
